import { render, staticRenderFns } from "./WorkClientModal.vue?vue&type=template&id=ba757d3c&scoped=true&"
import script from "./WorkClientModal.vue?vue&type=script&lang=js&"
export * from "./WorkClientModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientModal.vue?vue&type=style&index=0&id=ba757d3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba757d3c",
  null
  
)

export default component.exports